(function() {
  exports.Category = (function() {
    function Category() {
      this.id = null;
      this.display_name = '';
      this.headings = [];
      this.active = false;
      this.is_fixed = false;
    }

    return Category;

  })();

}).call(this);
